<div class="row">
    <!-- SK14MAY24 size customize in dashboard -->
    <div *ngFor="let report of chartArray" [class]="report.size || 'col-md-6'" >
        <app-charts [filterType]="report.filterType" [data]="report.mappedData" [chart]="report.chart" [label]="report.label"></app-charts>
    </div>
</div>
